import React from "react";
import { Global, css } from "@emotion/react";

const GlobalStyles = () => (
  <Global
    styles={(theme) => css`
      html {
        box-sizing: border-box;
      }

      *,
      *::before,
      *::after {
        box-sizing: inherit;
      }

      body {
        font-size: ${theme.typography.text.basic.sm};
        font-weight: 400;
        font-family: ${theme.typography.fontFamily};
        color: ${theme.colors.textBright};

        @media (min-width: ${theme.layout.breakpoints.md}) {
          font-size: ${theme.typography.text.basic.md};
        }

        @media (min-width: ${theme.layout.breakpoints.lg}) {
          font-size: ${theme.typography.text.basic.lg};
        }

        @media (min-width: ${theme.layout.breakpoints.xl}) {
          font-size: ${theme.typography.text.basic.xl};
        }
      }
    `}
  />
);

export default GlobalStyles;
